import dynamic from "next/dynamic";
const Header = dynamic(() => import("./common/header"));
const Footer = dynamic(() => import("./common/troofooter"));
import CookieConsent from "../components/common/CookieConsent/CookieConsent";
import { Provider } from "react-redux";
import store from "../store/store";
import { useEffect, useState } from "react";

const FreeConsultation = dynamic(() => import('../components/modals/FreeConsultation'))

const Layout = ({ children, isNew = false, slug }) => {
	const [show, setShow] = useState(false)
	const [isShowed, setIsShowed] = useState(false)
	const showModal = () => setShow(true)
	const hideModal = () => setShow(false)

	useEffect(() => {
		const handleMouseOut = (e) => {
			// Detect if the mouse leaves at the top of the window
			const cookiePopupRfp = document.cookie.split(';').find(x => x.trim().startsWith('popuprfp_submitted'));
			const isPopupRfpSubmitted = cookiePopupRfp ? cookiePopupRfp.split('=')[1] === 'true' : false;
			if (e.clientY <= 0 && !show && !isShowed && !isPopupRfpSubmitted) {
				showModal();
				setIsShowed(true);
			}
		};

		document.addEventListener("mouseout", handleMouseOut);
		return () => document.removeEventListener("mouseout", handleMouseOut);
	}, [show, isShowed]);

	useEffect(() => {
		console.log('on slug change called', slug)
		setIsShowed(false)
		setShow(false)
	}, [slug])

	return (
		<Provider store={store}>
			<div id="root">
				<Header isNew={isNew} pageSlug={slug} />
				<main className="middle-section middle-pad">
					{children}
				</main>
				<Footer />
				<CookieConsent />
				<FreeConsultation show={show} hide={hideModal} />
			</div>
		</Provider>
	);
};
export default Layout;
